import {
  AfterViewInit, ChangeDetectorRef, Component, Input,
  OnChanges, OnDestroy, OnInit, SimpleChanges
} from '@angular/core';
import { RawUser } from '@karve.it/interfaces/auth';
import { Store } from '@ngrx/store';

import { LazyLoadEvent } from 'primeng/api';
import { Tag } from 'primeng/tag';
import { SubSink } from 'subsink';

import { EstimatesJobFragment, FullTransactionFragment, TransactionsGQL, TransactionsQueryVariables } from '../../generated/graphql.generated';

import { pagination } from '../global.constants';
import { DetailsHelperService } from '../services/details-helper.service';
import { CreateDocumentDialogActions } from '../shared/create-document-dialog/create-document-dialog.actions';
import { WatchQueryHelper } from '../utilities/watchQueryHelper';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit, OnChanges {

  //ViewChild('transactionSearchInput', { static: true }) searchInput!: ElementRef;

  @Input() user: RawUser;
  @Input() job: EstimatesJobFragment;
  @Input() retrieveOnLoad = true;

  // FILTER VARIABLES
  @Input() filter: TransactionsQueryVariables['filter'] = {};
  @Input() pagination = pagination;

  // MODIFY COMPONENT LAYOUT
  // Show seperate header card
  @Input() showHeaderCard = true;
  // Show title in the card with the table
  @Input() smallTitle = false;
  // Show the button to open send receipt
  @Input() showReceiptButton = false;

  @Input() emptyMessage = pagination.emptyMessage;

  subs = new SubSink();

  tags: Tag[] = [];

  // Component Variables
  transactions: FullTransactionFragment[] = [];

  // Transaction Query Variables
  transactionsQueryRef!: ReturnType<typeof this.transactionGQL.watch>;
  transactionsQH: WatchQueryHelper = {
    limit: 5,
    skip: 0,
    loading: true,
    search: ''
  };

  constructor(
    private detailsHelper: DetailsHelperService,
    private ref: ChangeDetectorRef,
    private transactionGQL: TransactionsGQL,
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.transactions = [];

    this.subs.sink = this.detailsHelper.getObjectUpdates([
      'Transactions',
      'Invoice',
    ]).subscribe(() => {
      this.retrieveTransactions(true);
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  ngAfterViewInit() {
    this.ref.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('job' in changes
      && changes?.job?.currentValue?.id !== changes?.job?.previousValue?.id) {
      this.retrieveTransactions();
    }
    // this.transactionsQH.limit = this.pagination.defaultNumberOfItems;
  }

  retrieveTransactions(refetch = false) {
    const transactionInput = {
      filter: this.filter,
      limit: this.transactionsQH.limit,
    } as TransactionsQueryVariables;

    if (!this.transactionsQueryRef) {

      this.transactionsQueryRef = this.transactionGQL.watch(transactionInput);

      this.subs.sink = this.transactionsQueryRef.valueChanges.subscribe((res) => {
        this.transactionsQH.loading = res.loading;
        if(res.loading) return;

        if (res.networkStatus === 7) {
          this.transactions = res.data.transactions.transactions;
          this.transactionsQH.total = res.data.transactions.total;
        }
      });
    } else if (refetch) {
      this.transactionsQueryRef.refetch(transactionInput);
    } else {
      this.transactionsQueryRef.setVariables(transactionInput);
    }
  }

  // Pagination
  retrieveMoreTransactions(event: LazyLoadEvent) {

    this.transactionsQH.limit = event.rows;
    this.transactionsQH.skip = event.first;

    this.retrieveTransactions();
  }

  selectTransaction(transaction: FullTransactionFragment) {
    this.detailsHelper.detailsItem.next({ type: 'transaction', item: transaction });
  }

  openSendReceipt() {
    this.store.dispatch(CreateDocumentDialogActions.sendReceiptButtonClicked({ jobId: this.job.id }));
  }

  openTransactionInvoice(transaction: FullTransactionFragment) {

    if (!transaction.invoice) { return; }

    this.detailsHelper.detailsItem.next({ type: 'invoice', item: { id: transaction.invoice.id } });

  }
}
